<template>
  <div class="loading-state">
    <v-progress-circular
      indeterminate
      color="primary"
      bg-color="grey-lighten-2"
      :size="44"
      :width="3"
      class="mb-5"
    ></v-progress-circular>
    <p class="loading-state__title">{{ title }}</p>
    <p v-if="subtitle" class="loading-state__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  align-self: stretch;
  padding: 48px 24px;
  border-radius: 12px;
  background-color: #f8f6f0;
  text-align: center;
  animation: loading-state-fade-in 0.4s ease-out;
}

.loading-state__title {
  margin: 0;
  font-family: 'Lora', serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--primary);
}

.loading-state__subtitle {
  margin: 6px 0 0;
  font-family: 'Lora', serif;
  font-size: 13px;
  color: var(--text-color-grey);
}

@keyframes loading-state-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
